<template>
  <div>
    <div
      v-if="
        Object.keys(sondage_data_resultats).length ||
          Object.keys(sondage_libre_resultats).length
      "
    >
      <div
        style="padding: 10px"
        class="bloc"
        v-for="(section, index) in sections"
        :key="section.id"
      >
        <SectionTitle
          :window="window"
          :type="'all'"
          :index="index"
          :entitled_all="section.entitled"
        />
        <!-- si on a du texte libre avec d'autres questions de type 'checkboxes', 'choix unique', etc -->
        <div v-for="question in section.questions" :key="question.id">
          <div style="margin-top:5px;padding:5px; border:1px solid #e6ecf0">
          <div v-if="Object.keys(sondage_data_resultats).length">
            <SectionTitleOthers
              :position="'center'"
              :sondage_data_resultats="sondage_data_resultats"
              :questionId="question.id"
              :window="window"
            />
            <BarChart
              style="margin-left:-11px"
              ref="barchart"
              :questionId="
                question.element_type !== 'content' ? question.id : ''
              "
              v-if="
                question.element_type !== 'content' &&
                  Object.keys(sondage_data_resultats).some(
                    id => id === JSON.stringify(question.id)
                  ) &&
                  sondage_vue_type_resultats === 'bar'
              "
              :donnees="
                question.element_type !== 'content'
                  ? sondage_data_resultats[question.id]
                  : ''
              "
            />
            <PieChart
              style="margin-left: -11px"
              ref="piechart"
              :questionId="
                question.element_type !== 'content' ? question.id : ''
              "
              v-if="
                question.element_type !== 'content' &&
                  Object.keys(sondage_data_resultats).some(
                    id => id === JSON.stringify(question.id)
                  ) &&
                  sondage_vue_type_resultats === 'pie'
              "
              :resultatQueston="
                question.element_type !== 'content'
                  ? sondage_data_resultats[question.id]
                  : ''
              "
            />
            <br />
          </div>
          <div v-if="Object.keys(sondage_libre_resultats).length">
            <LibreResultats
              v-if="
                Object.keys(sondage_libre_resultats).some(
                  id => id === JSON.stringify(question.id)
                )
              "
              :intitule="sondage_libre_resultats[question.id].intitule"
              :reponses="sondage_libre_resultats[question.id]"
            />
          </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import BarChart from '@/components/resultats/charts/BarChart'
import PieChart from '@/components/resultats/charts/PieChart'
import StarRating from 'vue-star-rating'
import LibreResultats from '@/components/resultats/LibreResultats'
import SectionTitle from './SectionTitle'
import SectionTitleOthers from './SectionTitleOthers'
import { mapGetters } from 'vuex'

export default {
  name: 'AllResultats',
  components: {
    BarChart,
    PieChart,
    StarRating,
    LibreResultats,
    SectionTitle,
    SectionTitleOthers
  },
  props: {
    window: {
      required: true
    }
  },
  data () {
    return {
      currentSlide: 0,
      arrayOfResults: []
    }
  },
  computed: {
    ...mapGetters([
      'sections',
      'type_formulaire',
      'sondage_vue_type_resultats',
      'sondage_libre_resultats',
      'sondage_data_resultats'
    ])
  },
  watch: {
    sondage_data_resultats () {
      this.donnees = this.sondage_data_resultats
    }
  },
  created () {
    this.$store.commit('UNSET_CHARTS_REFS')
  }
}
</script>



// WEBPACK FOOTER //
// src/components/resultats/section/AllResultatsSection.vue